
export const GET_WORK_DAYS_SUCCESS = "GET_WORK_DAYS_SUCCESS";

export const GET_ALL_USERS_WORK_DAYS = "GET_ALL_USERS_WORK_DAYS";

export const OPEN_CLOSE_PERIOD = "OPEN_CLOSE_PERIOD";
